export const navigate = (history, url) => history?.push(url);
